







































































import { FormsApi, RequestNewProductCommand } from "@/api";
import stateMixin from "@/mixins/state";

export default {
  data() {
    return {
      valid: true,
      fields: {
        drugName: "",
        drugStrength: "",
        consumptionPerWeek: "",
        amountOfPatients: undefined,
        ziNumber: "",
        reason: ""
      },
      rules: {
        drugNameRules: [(v: string) => !!v || "Naam geneesmiddel is verplicht"],
        drugStrengthRules: [
          (v: string) => !!v || "Geneesmiddel sterkte is verplicht"
        ],
        consumptionPerWeekRules: [
          (v: string) => !!v || "Verbruik is verplicht"
        ],
        amountOfPatients: [
          (v: number) => !!v || "Aantal patienten is verplicht"
        ],
        ziNumber: [(v: string) => !!v || "ZI-nummer is verplicht"],
        reason: [(v: string) => !!v || "Reden is verplicht"]
      }
    };
  },
  mixins: [stateMixin],
  methods: {
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsRequestNewProduct({
            ...this.fields,
            amountOfPatients: this.fields.amountOfPatients || 0
          });
          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  }
};
